export default function getSubAvatarIconSize(size: number)
{
    return 11;
}
